<template>
  <Modal :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <div class="space-y-4">
      <div class="flex justify-between items-center">
        <h3 class="text-lg font-medium leading-6 text-gray-900 w-full text-center">{{ t('slides_editor.components.cover_selection_modal.title') }}</h3>
        <button
          type="button"
          @click="$emit('update:modelValue', false)"
          class="text-gray-400 hover:text-gray-500"
        >
          <span class="sr-only">{{ t('slides_editor.components.cover_selection_modal.close') }}</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div>
        <!-- Grid of cover images -->
        <div class="grid grid-cols-4 gap-4 overflow-y-auto max-h-[60vh] p-6">
          <div
            v-for="cover in covers"
            :key="cover.file_name"
            class="cursor-pointer"
            @click="selectCoverImage(cover)"
          >
            <div
              class="w-full rounded-lg aspect-square overflow-hidden border-2"
              :class="{ 'border-indigo-600': selectedCoverImage === cover.file_name, 'border-transparent': selectedCoverImage !== cover.file_name }"
            >
              <img
                :src="cover.url"
                :alt="t('slides_editor.components.cover_selection_modal.cover_alt', { name: cover.file_name })"
                class="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-4">
        <button
          type="button"
          @click="$emit('update:modelValue', false)"
          class="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {{ t('slides_editor.components.cover_selection_modal.cancel') }}
        </button>
        <button
          type="button"
          @click="saveCoverImage"
          class="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {{ t('slides_editor.components.cover_selection_modal.save') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import Modal from '../shared/Modal.vue'
import { t } from '@/libs/i18n'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  covers: {
    type: Array,
    required: true,
    default: () => []
  },
  initialSelectedCover: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'select-cover'])

const selectedCoverImage = ref(props.initialSelectedCover)

watch(() => props.initialSelectedCover, (newValue) => {
  selectedCoverImage.value = newValue
})

const selectCoverImage = (coverImage) => {
  selectedCoverImage.value = coverImage.file_name
}

const saveCoverImage = () => {
  emit('select-cover', selectedCoverImage.value)
  emit('update:modelValue', false)
}
</script>
